import isMobileSize from './isMobileSize';
import config from '../utils/config';

const template = () => (!isMobileSize ? document.getElementById('notification-item-template-desktop') : document.getElementById('notification-item-template-mobile')) || null;
const bellElement = () => document.querySelector('.notifications-bell') || null;

const hoveredCookieValue = 'notifications-hovered=true';
const wiggledCookieValue = 'notifications-wiggle=true';


function getItemId(str) {
    const match = str.match(/\/store\/detail\/([^\/]*)--/);
    if (match && match[1]) {
      return match[1];
    }
    return null;
  }

document.addEventListener('DOMContentLoaded', () => {
    bellElement()?.addEventListener('mouseenter', (e) => {
        e.target.classList.add('no-after')
        document.cookie = `${hoveredCookieValue};path=/;domain=.sweetwater.com;`;
    });
});

const notificationsServiceRootUrl = config.notificationsServiceRootUrl;
export default function setNotifications(notifications) {
    if (!Array.isArray(notifications)) return;
    if (!template()) return;

    window._all_notifications = notifications;
    if (notifications.length != 0) {
        Array.from(document.querySelectorAll('.notifications-mobile-title')).forEach(e => {
             e.classList.add('notifications-mobile-title--has-notifications')
        });
        if (!document.cookie.includes(wiggledCookieValue)) {
            bellElement()?.classList.add('notifications-bell--should-wiggle');
            document.cookie = `${wiggledCookieValue};path=/;domain=.sweetwater.com`;
        }
        if (document.cookie.includes(hoveredCookieValue)) {
            bellElement()?.classList.add('no-after');
        }
        bellElement()?.classList.add('notifications-bell--active');
        document.querySelector('.assets-site-header__menu-nav-toggle-text').classList.add('assets-site-header__menu-nav-toggle-text--has-notifications');
        document.querySelector('.notifications.notifications-badge').classList.add('notifications-badge--active');
    } else {
        document.querySelector('.assets-site-header__menu-nav-toggle-text').classList.remove('assets-site-header__menu-nav-toggle-text--has-notifications');
        bellElement()?.classList.remove('notifications-bell--active');
        document.querySelector('.notifications.notifications-badge').classList.remove('notifications-badge--active');
        Array.from(document.querySelectorAll('.notifications-mobile-title')).forEach(e => {
             e.classList.remove('notifications-mobile-title--has-notifications')
        });
    }


    const containers = Array.from(document.querySelectorAll('.notifications-dropdown'));
    containers.forEach(container => container.innerHTML = '');
    notifications.forEach((notification) => {
          const itemid = getItemId(notification.link);
          if (itemid) {
            window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                  event: 'product-notification',
                  'product-notification-type': {
                        pricedrop: 'Price Drop',
                        backinstock: 'Back In Stock',
                        reorder: 'Time To Reorder',
                        demo: 'Demo Available'
                  }[notification.type],
                  itemid
              })
          }

        const notificationElement = makeNotificationItem(notification);
        if (notificationElement) {
            containers[isMobileSize() ? 1 : 0].appendChild(notificationElement);
        }
    });
}

function viewedNotification(uid, reciever_type, reciever_value, closed = false) {
    const notification = window._all_notifications.find(n => n.uid == uid);
    if (notification) {
        const itemid = getItemId(notification.link);
        if (itemid) {
          window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'product-notification-click',
                'product-notification-type': {
                      pricedrop: 'Price Drop',
                      backinstock: 'Back In Stock',
                      reorder: 'Time To Reorder',
                      demo: 'Demo Available'
                }[notification.type],
                itemid
            })
        }
    }


    if (window["clicked-on" + uid]) {
        // console.log("already logged interaction on notification:", uid);
    } else {
        fetch('/webservices_sw/personalization/notifications/cache', {
            method: 'DELETE',
        })
        fetch(`${notificationsServiceRootUrl}/customer-notifications-api/interaction`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify({
                reciever_type: reciever_type,
                reciever_value: reciever_value,
                notification_uid: uid,
                action_name: closed ? "dismiss" : "click"
            })
        });
        window["clicked-on" + uid] = true;
    }
}

function focusedNotification(uid, reciever_type, reciever_value) {
        console.log("hovered on", uid);
        fetch(`${notificationsServiceRootUrl}/customer-notifications-api/interaction`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify({
                reciever_type: reciever_type,
                reciever_value: reciever_value,
                notification_uid: uid,
                action_name: "focus"
            })
        });
}


function makeNotificationItem(notification) {
    const { uid, link, type, reason, image, title, price, oldPrice, lastOrderDate, recieverType, recieverValue } = notification;

    if (!uid, !link || !type || !image || !title || !price) {
        console.error('Call to makeNotificationItem did not have required arguments.', notification);
        return;
    }

    const newElement = template().cloneNode(true);
    newElement.classList.remove('removed');

    const oldPriceElement = newElement.querySelector('.notifications-item__text-priceold');
    if (!oldPrice) {
        oldPriceElement.remove();
    } else {
        oldPriceElement.innerHTML = `<sup>$</sup>${oldPrice.dollars}<sup>.${oldPrice.cents}</sup>`;
    }

    if (reason === 'previousOrder') {
        const lastOrderDateElement = newElement.querySelector('.notifications-item__last-order-date');
        lastOrderDateElement.innerText = lastOrderDate ? `Last Ordered ${lastOrderDate}` : 'Previously Ordered';
    }

    const priceElement = newElement.querySelector('.notifications-item__text-price');
    priceElement.innerHTML = `<sup>$</sup>${price.dollars}<sup>.${price.cents}</sup>`;

    const titleElement = newElement.querySelector('.notifications-item__text-title');
    titleElement.innerText = title;

    const imageElement = newElement.querySelector('.notifications-item__img img');
    imageElement.src = image;
    imageElement.setAttribute('alt', `Image for ${title}`);

    Array.from(newElement.querySelectorAll('.has-href-and-label')).forEach(element => {
        element.setAttribute('aria-label', `Click to visit ${title}`);
        element.href = link;
    })

    const pricedropBadge = newElement.querySelector('.notifications-badge__pricedrop');
    const backinstockBadge = newElement.querySelector('.notifications-badge__backinstock');
    const reorderBadge = newElement.querySelector('.notifications-badge__reorder');
    const demoBadge = newElement.querySelector('.notifications-badge__demo');

    newElement.id = `notification-${uid}--${Math.random() * 1000}`.split('.')[0];
    newElement.removeAttribute('style');


    switch (type) {
        case 'pricedrop':
            backinstockBadge.remove();
            reorderBadge.remove();
            demoBadge.remove();
            break;
        case 'backinstock':
            pricedropBadge.remove();
            reorderBadge.remove();
            demoBadge.remove();
            break;
        case 'reorder':
            backinstockBadge.remove();
            pricedropBadge.remove();
            demoBadge.remove();
            break;
        case 'demo':
            backinstockBadge.remove();
            reorderBadge.remove();
            pricedropBadge.remove();
            break;
    }

    const inCartReason = newElement.querySelector('.notifications-item__reason--in-cart');
    const recentlyViewedReason = newElement.querySelector('.notifications-item__reason--recently-viewed');
    const previousOrderReason = newElement.querySelector('.notifications-item__reason--previous-order');

    switch (reason) {
        case 'inCart':
            recentlyViewedReason.remove();
            previousOrderReason.remove();
            break;
        case 'recentlyViewed':
            inCartReason.remove();
            previousOrderReason.remove();
            break;
        case 'previousOrder':
            inCartReason.remove();
            recentlyViewedReason.remove();
            break;
        default:
            inCartReason.remove();
            recentlyViewedReason.remove();
            previousOrderReason.remove();
            break;
    }

    newElement.addEventListener('mouseenter', () => {
        focusedNotification(uid, recieverType, recieverValue);
    });

    newElement.addEventListener('click', (e) => {
        viewedNotification(uid, recieverType, recieverValue);
    });


    newElement.querySelector('.notifications-item__remove').addEventListener('click', (e) => {
        e.preventDefault();
        viewedNotification(uid, recieverType, recieverValue, true);
        newElement.classList.add('notifications-item--removing');
        window._all_notifications = window._all_notifications.filter(notification => notification.uid !== uid);
        setTimeout(() => {
            newElement.remove();
            if (window._all_notifications.length == 0) {
                setNotifications([]);
            }
        }, 300)
    });

    return newElement;
}

